import state from './stateFilter';
import actions from './actionFilter';
import mutations from './commitFilter';

export default {
    namespaced: true,
    state,
    actions,
    mutations,
}